import React from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

const WidgetLogin = (props) => {
  const { loginId } = props;
  const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const itemClick = (link) => {
    const { history } = props;
    history.push(link);
  };
  return (
    <>
      <div className="widget-container">
        {/* <div className="">
          <div className="widget-title">아래의 내용을 찾으셨나요?</div>
        </div> */}
        <div>
          <ul className="widget-content">
            {param === '아이디' || param === '비밀번호' || param === '계정' ? (
              <li onClick={() => itemClick('/find')}>
                아이디/비밀번호 찾기 바로가기
              </li>
            ) : param === '회원가입' ? (
              <li onClick={() => itemClick('/join')}>회원가입 바로가기</li>
            ) : param === '회원탈퇴' ? (
              loginId === '' || loginId === undefined ? (
                <li onClick={() => itemClick('/login')}>로그인 바로가기</li>
              ) : (
                <>
                  {loginId === '' || loginId === undefined ? (
                    <li onClick={() => itemClick('/login')}>로그인 바로가기</li>
                  ) : null}

                  <li onClick={() => itemClick('/edit')}>회원탈티 바로가기</li>
                </>
              )
            ) : param === '회원정보' ? (
              <>
                {loginId === '' || loginId === undefined ? (
                  <li onClick={() => itemClick('/login')}>로그인 바로가기</li>
                ) : null}
                <li onClick={() => itemClick('/edit')}>
                  회원정보수정 바로가기
                </li>
              </>
            ) : (
              <li onClick={() => itemClick('/login')}>로그인 바로가기</li>
            )}
          </ul>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
      <div className="widget-time">{props.childProps.payload.writetime}</div>
    </>
  );
};
export default shopContext(withRouter(WidgetLogin));
